import { lazy } from 'react';

export const BimCalculationOthers = lazy(() =>
    import('./BimCalculationOthers').then((module) => ({ default: module.BimCalculationOthers })),
);
